export const ACCEPTED_COUNTRY_CAPITALS = [
  "Kuwait City",
  "Ngerulmud",
  "Vaduz",
  "Chișinău",
  "Luanda",
  "Sucre",
  "Funafuti",
  "Lima",
  "Berlin",
  "Gaborone",
  "Kabul",
  "Budapest",
  "Ouagadougou",
  "Ottawa",
  "Jakarta",
  "Taipei",
  "Castries",
  "Libreville",
  "Monrovia",
  "Ankara",
  "Bamako",
  "Porto-Novo",
  "Nicosia",
  "Mogadishu",
  "Niamey",
  "Lisbon",
  "Dakar",
  "Havana",
  "Minsk",
  "Bridgetown",
  "Tunis",
  "Jerusalem",
  "Rome",
  "Naypyidaw",
  "Palikir",
  "Djibouti",
  "Brazzaville",
  "Kinshasa",
  "Belmopan",
  "Canberra",
  "Yaoundé",
  "Moscow",
  "Saint John's",
  "Tokyo",
  "Tegucigalpa",
  "Gitega",
  "Asunción",
  "Buenos Aires",
  "São Tomé",
  "Maseru",
  "Khartoum",
  "San Salvador",
  "Bishkek",
  "Brasília",
  "Phnom Penh",
  "Pretoria",
  "Bloemfontein",
  "Cape Town",
  "Guatemala City",
  "Washington, D.C.",
  "Baku",
  "Kuala Lumpur",
  "Bogotá",
  "Nouakchott",
  "Manama",
  "Brussels",
  "Santiago",
  "Skopje",
  "Maputo",
  "Addis Ababa",
  "New Delhi",
  "Madrid",
  "Nur-Sultan",
  "Muscat",
  "Abu Dhabi",
  "Warsaw",
  "St. George's",
  "Sri Jayawardenepura Kotte",
  "Dushanbe",
  "Damascus",
  "Tripoli",
  "Port-au-Prince",
  "City of San Marino",
  "Nuku'alofa",
  "Tbilisi",
  "Asmara",
  "Dodoma",
  "Prague",
  "Pristina",
  "Thimphu",
  "Cairo",
  "Basseterre",
  "Hanoi",
  "Majuro",
  "Vienna",
  "Port Moresby",
  "Nassau",
  "Zagreb",
  "Ljubljana",
  "Tashkent",
  "Helsinki",
  "Georgetown",
  "Monaco",
  "Bratislava",
  "Sana'a",
  "Lilongwe",
  "Banjul",
  "Panama City",
  "Dublin",
  "Seoul",
  "Athens",
  "Islamabad",
  "Yerevan",
  "Valletta",
  "Ashgabat",
  "Santo Domingo",
  "Honiara",
  "Port Vila",
  "Antananarivo",
  "Vientiane",
  "Ulan Bator",
  "Paris",
  "Bangui",
  "Mbabane",
  "London",
  "Reykjavik",
  "Kathmandu",
  "Accra",
  "Baghdad",
  "Bangkok",
  "Copenhagen",
  "Belgrade",
  "Kampala",
  "Podgorica",
  "Riyadh",
  "Amman",
  "Paramaribo",
  "Wellington",
  "Nairobi",
  "Mexico City",
  "Sarajevo",
  "Kingstown",
  "Victoria",
  "Sofia",
  "Riga",
  "Conakry",
  "Beirut",
  "Luxembourg",
  "Port Louis",
  "Tallinn",
  "Oslo",
  "Moroni",
  "Caracas",
  "Tehran",
  "Stockholm",
  "Suva",
  "Manila",
  "Montevideo",
  "Bern",
  "Port of Spain",
  "Kigali",
  "Tirana",
  "Bissau",
  "Yamoussoukro",
  "Pyongyang",
  "Andorra la Vella",
  "Malé",
  "Yaren",
  "Singapore",
  "Harare",
  "Roseau",
  "Rabat",
  "Doha",
  "San José",
  "Praia",
  "Amsterdam",
  "Bucharest",
  "Freetown",
  "Managua",
  "Algiers",
  "Kingston",
  "Lomé",
  "Vatican City",
  "Quito",
  "Apia",
  "Abuja",
  "Lusaka",
  "N'Djamena",
  "Vilnius",
  "Kyiv",
  "Beijing",
  "Ramallah",
  "Juba",
  "Dhaka",
  "Malabo",
  "Windhoek",
  "Dili",
  "Bandar Seri Begawan",
  "South Tarawa",
  "Sucre",
  "Cotonou",
  "St. Johns",
  "Bujumbura",
  "Cape Town",
  "Bloemfontein",
  "Washington",
  "PutraJaya",
  "Valparaiso",
  "Saint Georges",
  "Sri Jayawardenepura Kotte",
  "Nuku'alofa",
  "Dar es Salaam",
  "Sana",
  "Aden",
  "Lobamba",
  "Cetinje",
  "Abidjan",
  "The Hague",
  "Vatican",
  "Jerusalem",
  "South Tarawa",
];
